/**
 * Format a number as USD currency
 * @param {number} value - The numeric value to format
 * @param {boolean} showSign - Whether to show + sign for positive values
 * @returns {string} Formatted currency string
 */
export const formatUSD = (value, showSign = false) => {
  if (value === null || value === undefined || isNaN(value)) {
    return "$0.00";
  }

  const formatted = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Math.abs(value));

  if (value < 0) {
    return `-${formatted}`;
  }

  if (showSign && value > 0) {
    return `+${formatted}`;
  }

  return formatted;
};
